import { userReviews } from "@/mocks/gossip";

export default function Reviews() {
  return (
    <section id="reviews" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold text-accent-600">
              <i className="ri-chat-smile-2-line"></i> 网友开麦
            </p>
            <h2 className="serif-title mt-2 text-3xl font-black text-foreground-950 md:text-4xl">
              每晚十点，一起收摊
            </h2>
          </div>
          <span className="flex items-center gap-2 text-sm text-foreground-500">
            <i className="ri-star-fill text-accent-500"></i>
            社区好评 4.9 / 5
            <span className="mx-1 h-4 w-px bg-background-200"></span>
            <span className="font-semibold text-foreground-700">128k</span> 位夜猫子在线
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {userReviews.map((r) => (
            <figure
              key={r.author}
              className="flex flex-col justify-between rounded-2xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-accent-200"
            >
              <div>
                <div className="flex items-center gap-1 text-accent-500">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                  “{r.quote}”
                </blockquote>
              </div>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-user-3-line"></i>
                </span>
                <span>
                  <p className="text-sm font-semibold text-foreground-900">{r.author}</p>
                  <p className="text-xs text-foreground-500">{r.role}</p>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}